// Jquery
import $ from 'jquery';
import { Dropdown } from '../modules/components/dropdown.js';

/**
 * LeftSidebar
 */
export default class LeftSidebar {

	constructor() {
		this.body = $(document.body);
		this.window = $(window);
		this.menuContainer = $('#mp-menubar');
	}

	/**
	 * Reset the theme
	 */
	_reset() {
		this.body.removeAttr('data-leftbar-theme');
	}

	/**
	 * Activates the condensed side bar
	 */
	activateCondensedSidebar() {
		this.body.attr('data-leftbar-compact-mode', 'condensed');
	}

	/**
	 * Deactivates the condensed side bar
	 */
	deactivateCondensedSidebar() {
		this.body.removeAttr('data-leftbar-compact-mode');
	}

	/**
	 * Activates the scrollable sidenar
	 */
	activateScrollableSidebar() {
		this.body.attr('data-leftbar-compact-mode', 'scrollable');
	}

	/**
	 * Deactivates the scrollbar
	 */
	deactivateScrollableSidebar() {
		this.body.removeAttr('data-leftbar-compact-mode');
	}

	/**
	 * Activates the default theme
	 */
	activateDefaultTheme() {
		this._reset();
		this.body.attr('data-leftbar-theme', 'default');
	}

	/**
	 * Activates the light theme
	 */
	activateLightTheme() {
		this._reset();
		this.body.attr('data-leftbar-theme', 'light');
	}

	/**
	 * Activates the dark theme
	 */
	activateDarkTheme() {
		this._reset();
		this.body.attr('data-leftbar-theme', 'dark');
	}

	/**
	 * Initializes the menu
	 */
	initMenu() {

		const that = this;
		// resets everything
		this._reset();

		/*
		 * click events
		 * Left menu collapse
		 */
		$(document).on('click', '.button-menu-mobile', (e) => {
			e.preventDefault();

			// if (that.body.attr('data-layout') === 'full') {
			// 	that.body.toggleClass('hide-menu');
			// }
			// else {
			// if (that.window.width() < 768) {
			// 	that.body.toggleClass('hide-menu');
			// }
			// else {
			if (that.body.attr('data-leftbar-compact-mode') === 'condensed') {
				that.body.addClass('sidebar-enable');
				that.deactivateCondensedSidebar();
			}
			else {
				that.body.removeClass('sidebar-enable');
				that.activateCondensedSidebar();
			}
			// }
			// }

		});

		// sidebar - main menu
		if ($('.side-nav').length > 0) {
			const navCollapse = $('.side-nav li .collapse');
			const navToggle = $('.side-nav li [data-bs-toggle=\'collapse\']');

			// Prevent click on links that have a href set
			navToggle.on('click', false);

			// open only one menu at a time only
			navCollapse.on({
				'show.bs.collapse': function(event) {
					// console.log('collapse show: %o, event: %o', this, event);
					const $parents = $(event.target).parents('.collapse.show');
					$('.side-nav .collapse.show').not(event.target).not($parents).collapse('hide');
				},
				// 'shown.bs.collapse': function(event) {
				// 	console.log('collapse shown: %o, event: %o', this, event);
				// },
				// 'hide.bs.collapse': function(event) {
				// 	console.log('collapse hide: %o, event: %o', this, event);
				// 	// debugger;
				// },
				// 'hidden.bs.collapse': function(event) {
				// 	console.log('collapse hidden: %o, event: %o', this, event);
				// },
			});

			// ? ===========================================
			// TODO: add click event handler on the link element with href to set it as selected with js also (for ajax-navigation)
			// ? ===========================================

			// activate the menu in left side bar (Vertical Menu) based on url
			$('.side-nav a').each(/** @this {HTMLAnchorElement} */ function() {
				const pageUrl = window.location.href.split(/#/)[0];

				// @ts-ignore
				if (this.href === pageUrl) {
					return;
					$(this).addClass('active');
					$(this).parent().addClass('menuitem-active');
					$(this).parent().parent().parent().addClass('show');
					$(this).parent().parent().parent().parent().addClass('menuitem-active'); // add active to li of the current link

					// const [el, parent1, parent2, parent3] = [this, this.parentElement, this.parentElement.parentElement, this.parentElement.parentElement.parentElement];
					// debugger;

					const firstLevelParent = $(this).parent().parent().parent().parent().parent().parent();
					if (firstLevelParent.attr('id') !== 'sidebar-menu') {
						firstLevelParent.addClass('show');
					}

					$(this).parent().parent().parent().parent().parent().parent().parent().addClass('menuitem-active');

					const secondLevelParent = $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent();
					if (secondLevelParent.attr('id') !== 'wrapper') {
						secondLevelParent.addClass('show');
					}

					const upperLevelParent = $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().parent();
					if (!upperLevelParent.is('body')) {
						upperLevelParent.addClass('menuitem-active');
					}

					// const [el, parent1, parent2, parent3] = [this, this.parentElement, this.parentElement.parentElement, this.parentElement.parentElement.parentElement];
					// console.log(this, this.parentElement, this.parentElement.parentElement, this.parentElement.parentElement.parentElement);
					// debugger;
				}
			});
		}

		// Horizontal Menu (For SM Screen)
		const AllNavs = document.querySelectorAll('ul.navbar-nav .dropdown .dropdown-toggle');
		let isInner = false;

		for (const element of AllNavs) {
			element.addEventListener('click', (event) => {
				if (!element.parentElement.classList.contains('nav-item')) {
					isInner = true;
					// element.parentElement.parentElement.classList.add('show');
					const parent = element.parentElement.parentElement.parentElement.querySelector('.nav-link');
					Dropdown.getInstance(parent).show();
					if (element.ariaExpanded) {
						Dropdown.getInstance(element).hide();
					}
					else {
						Dropdown.getInstance(parent).show();
					}
					isInner = true;
				}
			});

			element.addEventListener('hide.bs.dropdown', (event) => {
				if (isInner) {
					event.preventDefault();
					event.stopPropagation();
					isInner = false;
				}
			});

			element.addEventListener('show.bs.dropdown', (event) => {
				if (!isInner && !element.parentElement.classList.contains('nav-item')) {
					event.preventDefault();
					event.stopPropagation();
					isInner = true;
				}
			});
		}
	}
	/**
	 * Initializes the menu
	 */
	init() {
		this.initMenu();
	}
}
